/*
 * @Email: zheniscool@163.com
 * @FilePath: /cbibank-web-corporbank/src/utils/form/genrules.js
 * @Date: 2021-12-15 16:17:23
 * @Author: zhangzhen
 * @LastEditTime: 2022-02-09 14:58:07
 */
import i18n from '@/lang'

/**
 *  生成必填规则
 */
export const genRequiredRule = (wrongtips = '请输入', trigger = 'blur') => {
  return { required: true, message: i18n.t(wrongtips), trigger }
}

export const genRegTestRule = (reg, wrongtips = '输入的内容格式有误', trigger = 'blur', nullable = false) => {
  return {
    validator: function (rule, value, next) {
      if (nullable) {
        if (!value.trim()) {
          return next()
        }
      }
      if (reg.test(value.trim())) {
        next()
      } else {
        next(new Error(i18n.t(wrongtips)))
      }
    },
    trigger
  }
}
export const genRegTestRuleReverse = (reg, wrongtips = '输入的内容格式有误', trigger = 'blur') => {
  return {
    validator: function (rule, value, next) {
      if (!reg.test(value.trim())) {
        next()
      } else {
        next(new Error(i18n.t(wrongtips)))
      }
    },
    trigger
  }
}

export const genFormatValidateRule = (formatValidate, wrongtips = '输入的内容格式有误', trigger = 'blur') => {
  return {
    validator: function (rule, value, next) {
      if (!formatValidate(value)) {
        next()
      } else {
        next(new Error(i18n.t(wrongtips)))
      }
    },
    trigger
  }
}
